import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Copy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M9.705 6.93c0-.528.428-.956.956-.956h28.234c.528 0 .955.428.955.955v36.535a.955.955 0 0 1-.955.956H10.66a.955.955 0 0 1-.956-.956V6.93Zm1.912.955v34.624h26.322V7.885H11.617Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M6.202 2.33a.14.14 0 0 0-.14.14v35.81a.955.955 0 0 1-1.912 0V2.47c0-1.118.905-2.05 2.052-2.05h27.176a.955.955 0 1 1 0 1.91H6.202ZM15.757 33.923c0-.528.428-.955.956-.955h16.13a.956.956 0 1 1 0 1.91h-16.13a.955.955 0 0 1-.956-.955Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.757 25.197c0-.528.428-.955.956-.955h16.13a.956.956 0 1 1 0 1.91h-16.13a.955.955 0 0 1-.956-.955ZM15.757 16.47c0-.527.428-.954.956-.954h16.13a.956.956 0 1 1 0 1.91h-16.13a.955.955 0 0 1-.956-.955Z"
  })));
});
Copy.displayName = 'Copy';
Copy.defaultProps = {
  'aria-label': 'Copy'
};
export default Copy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Copy.js
// module id = 3132
// module chunks = 11